import { memo } from 'react';
import styled from '@emotion/styled';

type Props = {
  className?: string;
} & ChildrenProps;

export const Toolbar = memo(({ children, className }: Props) => {

  return (
    <ToolbarWrapper className={className}>
      {children}
    </ToolbarWrapper>
  );
});

const ToolbarWrapper = styled.div(({ theme }) => ({
  display: 'inline-flex',
  border: `1px solid ${theme.palette.gray.light2}`,
  borderRadius: '5px',
  padding: '4px',
  alignItems: 'center',
}));
